import React from 'react';

const Spearator = () => (
  <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />
);

export default Spearator;
